import generateQueryParams from '@/utils/generateQueryParams';
import axiosInstance from '@/plugins/api/axiosInstance';

export default function pickups() {
    return {
        index,
        get,
        save,
        addItem,
        updateItem,
        removeItem,
        remove,
        addImage,
        removeImage,
        printLabel,
        printCustomLabel
    };

    function index(options = {}) {
        const defaultValues = {
            limit: 25,
            page: 1,
            pattern: null
        };
        const params = generateQueryParams(options, defaultValues);
        return axiosInstance.get(`pickup/search${params}`);
    }

    function get(pickupId) {
        return axiosInstance.get(`pickup/get?id=${pickupId}`);
    }

    function save(payload) {
        if (payload.pickupId) {
            return axiosInstance.patch('pickup/update', payload);
        } else {
            return axiosInstance.post('pickup/create', payload);
        }
    }

    function addItem(pickupId, payload) {
        return axiosInstance.post('pickup/add-item', {
            pickupId,
            ...payload
        });
    }

    function updateItem(pickupId, payload) {
        return axiosInstance.patch('pickup/update-item', {
            pickupId,
            ...payload
        });
    }

    function removeItem(pickupId, id) {
        return axiosInstance.delete('pickup/remove-item', {
            data: {
                pickupId,
                id
            }
        });
    }

    function remove(id) {
        return axiosInstance.delete('pickup/delete', {
            data: {
                id
            }
        });
    }

    function addImage(pickupId, file) {
        const formData = new FormData();
        formData.append('files[]', file);
        formData.append('id', pickupId);

        return axiosInstance.post('pickup/add-image', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    }

    function removeImage(pickupId, imageId) {
        return axiosInstance.delete('pickup/delete-image', {
            data: {
                pickupId: pickupId,
                imageId: imageId
            }
        });
    }

    function printLabel(id) {
        return axiosInstance.get(`pickup/label?id=${id}`, {
            timeout: 60000,
            responseType: 'arraybuffer',
            headers: {
                Accept: 'application/pdf',
                'Content-Type': 'application/json'
            }
        });
    }

    function printCustomLabel(id, formatId) {
        return axiosInstance.get(
            `pickup/label-custom?id=${id}&labelFormatId=${formatId}`,
            {
                timeout: 60000,
                responseType: 'arraybuffer',
                headers: {
                    Accept: 'application/pdf',
                    'Content-Type': 'application/json'
                }
            }
        );
    }
}
